import React from 'react';
import {
    Box,
    Card,
    Text,
    Spinner,
    Alert,
    AlertIcon,
    Button
} from '@chakra-ui/react';

const ChannelsTable = ({ channelsData, loading, error, onRetry }) => {
   
    if (loading) {
        return (
            <Box p={6} textAlign="center">
                <Spinner size="xl" color="blue.500" />
                <Text mt={4} color="gray.600">Loading channels data...</Text>
            </Box>
        );
    }

    if (error) {
        return (
            <Box p={6}>
                <Alert status="error" borderRadius="md">
                    <AlertIcon />
                    {error}
                </Alert>
                <Button mt={4} onClick={onRetry} colorScheme="blue">
                    Retry
                </Button>
            </Box>
        );
    }

    if (!channelsData) {
        return (
            <Box p={6} textAlign="center">
                <Text color="gray.500">No channels data available</Text>
            </Box>
        );
    }

    const { channel_performance_comparison, summary } = channelsData;

    const getChannelColor = (channel) => {
        switch (channel.toLowerCase()) {
            case 'whatsapp':
                return 'green';
            case 'sms':
                return 'blue';
            case 'email':
                return 'purple';
            default:
                return 'gray';
        }
    };



    const thStyle = {
        padding: '16px',
        fontSize: '14px',
        fontWeight: '600',
        color: '#4a5568',
        textAlign: 'center', // ✅ center text in headers
    };

    const tdStyle = {
        padding: '16px',
        textAlign: 'center', // ✅ center all cells
        fontSize: '14px',
        color: 'black',
        fontWeight: '500',
    };

    const trStyle = {
        borderBottom: '1px solid #f7fafc',
    };


    return (
        <Box >


            {/* Channel Performance Table */}
            <Card p={0} borderRadius="lg" shadow="sm" overflow="hidden">
                <Box p={4} borderBottom="1px solid #e2e8f0">
                    <Text fontWeight="semibold" fontSize="lg" color="gray.800">
                        Channel Performance Comparison
                    </Text>
                    <Text fontSize="sm" color="gray.600">
                        Detailed performance metrics for each communication channel
                    </Text>
                </Box>

                <Box overflowX="auto">
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            textAlign: 'center',
                        }}
                    >
                        <thead style={{ backgroundColor: '#f7fafc' }}>
                            <tr>
                                <th style={{ ...thStyle, textAlign: 'left' }}>Channel</th>
                                <th style={thStyle}>Messages Sent</th>
                                <th style={thStyle}>Delivered</th>
                                <th style={thStyle}>Read Rate</th>
                                <th style={thStyle}>Fail</th>
                            </tr>
                        </thead>

                        <tbody>
                            {channel_performance_comparison?.length > 0 ? (
                                channel_performance_comparison.map((channel, index) => (
                                    <tr key={index} style={trStyle}>
                                        <td style={{ ...tdStyle, textAlign: 'left' }}>
                                            <Text fontSize="14px" fontWeight="600" color="black">
                                                {channel.channel}
                                            </Text>
                                        </td>
                                        <td style={tdStyle}>{channel.messages_sent?.toLocaleString() || 0}</td>
                                        <td style={tdStyle}>
                                            <Text fontSize="14px" fontWeight="500" color="black">
                                                {channel.delivered?.toLocaleString() || 0}
                                            </Text>
                                            <Text fontSize="xs" color="gray.600">
                                                {channel.delivery_rate}%
                                            </Text>
                                        </td>
                                        <td style={tdStyle}>
                                            <Text fontSize="14px" fontWeight="600" color="black">
                                                {channel.read}
                                            </Text>
                                            <Text fontSize="xs" color="gray.600">
                                                {channel.read_rate}%
                                            </Text>
                                        </td>
                                        <td style={tdStyle}>
                                            <Text fontSize="14px" fontWeight="600" color="black">
                                                {channel.failed}
                                            </Text>
                                            <Text fontSize="xs" color="gray.600">
                                                {channel.failed_rate}%
                                            </Text>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td
                                        colSpan="8"
                                        style={{ padding: '32px', textAlign: 'center', color: '#a0aec0' }}
                                    >
                                        No channel performance data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </Box>

            </Card>


        </Box>
    );
};

export default ChannelsTable;